import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';
import NoSsr from '@material-ui/core/NoSsr';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';

import withStyles from '@material-ui/core/styles/withStyles';

import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { asField } from 'informed';
import { get } from 'lodash-es';

// TODO: rewrite block code below to follow eslint rules
/* eslint-disable */
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 14,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 14,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  // Fix https://github.com/JedWatson/react-select/issues/3128#issuecomment-439207355
  const { onMouseMove, onMouseOver, ...newInnerProps } = props.innerProps;

  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        whiteSpace: 'normal',
        height: 'auto',
      }}
      {...newInnerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}
const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};
/* eslint-enable */

class LenderSelect extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
    this.state = {
      option_true: false,
    };
  }

  static componentDidMount() {
    const { fieldState, type, fetchLenderAddresses } = this.props;
    if (type === 'lenders' && fieldState.value) fetchLenderAddresses(fieldState.value);
  }

  // eslint-disable-next-line no-unused-vars
  handleChange = name => option => {
    const { fieldApi, type, onChange, fetchLenderAddresses } = this.props;
    if (option) {
      const { value } = option;
      if (type === 'lenders' && value) {
        fetchLenderAddresses(value);
      }
      fieldApi.setValue(value);
      if (onChange) {
        onChange(value);
      }
    } else {
      // reset field
      fieldApi.setValue(undefined);
      if (onChange) {
        onChange(undefined);
      }
    }
  };

  enableOption = input => {
    const optionTrue = get(this.state, 'option_true');
    if (typeof input === 'string' && input.length > 2) {
      if (!optionTrue) {
        this.setState({ option_true: true });
      }
    } else if (optionTrue) {
      this.setState({ option_true: false });
    }
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const { value } = fieldState;
    // const { setTouched } = fieldApi;
    const {
      theme,
      classes,
      isLoading,
      isClearable,
      isSearchable,
      // onChange,
      // onBlur,
      field,
      // initialValue,
      // children,
      multiple,
      /* forwardedRef, //Warning: React does not recognize the `forwardedRef` prop on a DOM element. */
      label = '',
      placeholder = '',
      // id = String(Math.floor(Math.random() * 1e8)),
      // helperText = '',
      options = [],
      // type,
      required,
      disabled,
      // ...rest
    } = props;

    const cleanValue = value ? options.find(option => option.value === value) : value;

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    const getOptions = () => {
      const length = get(options, 'length', 0);
      // only for huge list
      if (length > 1000) {
        return get(this.state, 'option_true', false) ? options : [];
      }
      return options;
    };

    return (
      <>
        <NoSsr>
          <Select
            required={required}
            classes={classes}
            styles={selectStyles}
            isDisabled={disabled}
            className={disabled ? 'disabled' : ''}
            isLoading={isLoading}
            isClearable={isClearable}
            isSearchable={isSearchable}
            multiple={multiple}
            ref={this.selectRef}
            name={field}
            options={getOptions()}
            defaultValue={cleanValue || (multiple ? [] : '')}
            value={cleanValue || (multiple ? [] : '')}
            components={components}
            placeholder={placeholder}
            textFieldProps={{
              label: required ? `${label} *` : label,
              InputLabelProps: {
                shrink: true,
              },
            }}
            onChange={this.handleChange(field)}
            onInputChange={this.enableOption}
          />
        </NoSsr>
      </>
    );
  }
}

LenderSelect.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  fetchLenderAddresses: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  fieldApi: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  fieldState: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  strings: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  type: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

LenderSelect.defaultProps = {
  options: [],
  fetchLenderAddresses: params => {
    console.log('fetchLenderAddresses::', ...params); // eslint-disable-line no-console
  },
  strings: {
    'lenders.label': 'Lender',
  },
  isDisabled: false,
  isLoading: false,
  isClearable: true,
  isSearchable: true,
  required: false,
  disabled: false,
};

export default asField(withStyles(styles, { withTheme: true })(LenderSelect));
